import { resolveUnpublishedComponent } from './prismicUnpublishedRegistry'

export const PRISMIC_REPOSITORY_NAME = 'px-pws-v3'

const localePrefix = (lang) => {
  if (!lang || lang === 'en-us') return ''
  return `/${lang}`
}

const blogPostPath = (doc) => {
  const legacyId = doc.data?.metadata_id_from_previous_repository
  const suffix = legacyId ? `/${legacyId}` : ''
  return `${localePrefix(doc.lang)}/blog/${doc.uid}${suffix}/`
}

const videoPath = (doc) => {
  const lastUrlPart = doc.data?.last_url_part
  if (!lastUrlPart) return '/preview/preview-unavailable/'
  return `${localePrefix(doc.lang)}/videos/${lastUrlPart}/`
}

const sammpsPath = (base) => (doc) => {
  if (!doc.lang || doc.lang === 'en-us') return `${base}/`
  return `${base}/${doc.lang.slice(0, 2)}/`
}

const routedPrismicLocales = {
  blog: new Set(['pt-pt', 'es-es']),
  'blog-post': new Set(['pt-pt', 'es-es']),
  video: new Set(['pt-pt', 'es-es']),
  'sammps-2024': new Set(['fr-fr', 'de-de', 'it-it', 'pt-pt', 'es-es']),
  'sammps-2024-2': new Set(['fr-fr', 'de-de', 'it-it', 'pt-pt', 'es-es']),
}

/**
 * Canonical production routes for preview redirect.
 * Fixed marketing pages resolve to the English URL; the preview session
 * remains active on locale-prefixed routes. Blog/video use the document lang.
 */
export const linkResolver = (doc) => {
  if (
    doc.lang &&
    doc.lang !== 'en-us' &&
    !routedPrismicLocales[doc.type]?.has(doc.lang)
  ) {
    return '/preview/preview-unavailable/'
  }

  switch (doc.type) {
    case 'homepage2025':
      return '/'
    case 'about':
      return '/about/'
    case 'support':
      return '/support/'
    case 'contact':
      return '/contact/'
    case 'privacy':
      return '/privacy/'
    case 'terms':
      return '/terms/'
    case 'affiliates-page':
      return '/partners/affiliates/'
    case 'smartalbums-overview-2025':
      return '/smartalbums/'
    case 'smartalbums-2022':
      return '/smartalbums/whatsnew/'
    case 'smartalbums-cloud-proofing':
      return '/smartalbums/cloud-proofing/'
    case 'smartalbums-pricing-2020':
      return '/pricing/smartalbums/'
    case 'smartalbums-download':
      return '/smartalbums/download/'
    case 'sa-mobile-download':
      return '/smartalbums/download/mobile/'
    case 'smartalbums-trial-sign-up':
      return '/mobile-trial-download-sign-up/mac/'
    case 'smartalbums-trial-sign-up-follow':
      return '/trial_download_sign_up_follow/mac/'
    case 'smartalbums-video-tutorials-2020':
      return '/tutorials-smartalbums/'
    case 'psf-overview-2026':
      return '/smartgalleries/'
    case 'galleries-examples':
      return '/smartgalleries/examples/'
    case 'psf-pricing-2020':
      return '/pricing/smartgalleries/'
    case 'galleries-mobile-access':
      return '/smartgalleries/mobile-smartgalleries-access/'
    case 'pss-overview':
      return '/smartslides/'
    case 'smartslides-examples':
      return '/smartslides/examples/'
    case 'smartslides-pricing-2020':
      return '/pricing/smartslides/'
    case 'mkt-landing-1':
      return '/smartalbums/aiassistant/'
    case 'mkt-landing-2':
      return '/landing2/'
    case 'sammps-2024':
      return sammpsPath('/sammps')(doc)
    case 'sammps-2024-2':
      return sammpsPath('/sammps2')(doc)
    case 'blog':
      return `${localePrefix(doc.lang)}/blog/`
    case 'blog-post':
      return blogPostPath(doc)
    case 'video':
      return videoPath(doc)
    default:
      return '/preview/preview-unavailable/'
  }
}

export const repositoryConfigs = [
  {
    repositoryName: PRISMIC_REPOSITORY_NAME,
    linkResolver,
    componentResolver: resolveUnpublishedComponent,
  },
]
